const stripHtmlToText = (html: string | null) => {
	if (!html) return '';

	return html.toString().replace(/<[^>]+>/g, '');
};

export default stripHtmlToText;
